import builder from '../builder';
import ArrowLeft1 from '../../streamline-icons/light/arrow-left-1.svg';

export default builder('IconArrowLeft1Light', ArrowLeft1);
